export const BACKGROUND_IMAGE_URL =
  'https://d26lpennugtm8s.cloudfront.net/assets/insti/img/login/login-background.jpg';

export const OLD_ADMIN_LOGOUT_ROUTE = '/auth/logout';
